// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lQm3","left":"styles_left__1R-i7"};